export default "__VITE_ASSET__D8NvgB4f__"